import { AuthProvider } from "@/auth/AuthContext";
import { RequireAuth } from "@/auth/RequireAuth";
import { AdminLayout } from "@/components/layout/AdminLayout";
import { Shell } from "@/components/layout/Shell";
import { TemplatesPage } from "@/pages/TemplatesPage";
import { UsersPage } from "@/pages/UsersPage";
import { AuditPage } from "@/pages/AuditPage";
import { ApiKeysPage } from "@/pages/ApiKeysPage";
import { BouncesPage } from "@/pages/BouncesPage";
import { BoardPage } from "@/pages/BoardPage";
import { EventEditorPage } from "@/pages/EventEditorPage";
import { LoginPage } from "@/pages/LoginPage";
import { MailHomePage } from "@/pages/MailHomePage";
import { NewEventPage } from "@/pages/NewEventPage";
import { QueuePage } from "@/pages/QueuePage";
import { SendersPage } from "@/pages/SendersPage";
import { SentMessagePage } from "@/pages/SentMessagePage";
import { SourcesPage } from "@/pages/SourcesPage";
import { ThemeProvider } from "@/themes/theme";
import { ArchivePage } from "@/pages/ArchivePage";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route element={<RequireAuth />}>
              <Route element={<Shell />}>
                <Route path="/" element={<MailHomePage />} />
                <Route path="/mails/new" element={<NewEventPage />} />
                <Route path="/events/:id" element={<EventEditorPage />} />
                <Route path="/board" element={<BoardPage />} />
                <Route path="/queue" element={<QueuePage />} />
                <Route path="/queue/messages/:id" element={<SentMessagePage />} />
                <Route path="/bounces" element={<BouncesPage />} />
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<Navigate to="sources" replace />} />
                  <Route path="sources" element={<SourcesPage />} />
                  <Route path="templates" element={<TemplatesPage />} />
                  <Route path="senders" element={<SendersPage />} />
                  <Route path="audit" element={<AuditPage />} />
                  <Route path="users" element={<UsersPage />} />
                  <Route path="api-keys" element={<ApiKeysPage />} />
                </Route>
                <Route path="/senders" element={<Navigate to="/admin/senders" replace />} />
                <Route path="/sources" element={<Navigate to="/admin/sources" replace />} />
                <Route path="/templates" element={<Navigate to="/admin/templates" replace />} />
                <Route path="/archive" element={<ArchivePage />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
